import { render, staticRenderFns } from "./DoctorTabStepForm.vue?vue&type=template&id=4aedd1dd&"
import script from "./DoctorTabStepForm.vue?vue&type=script&lang=js&"
export * from "./DoctorTabStepForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports